const PHONE_CHARACTERS = /^(?:\+|00)?[\d\s().-]+$/;

export function normalizeInternationalPhone(value: string): string {
  let phone = value.trim().replace(/[\s().-]/g, "");
  if (phone.startsWith("+")) phone = phone.slice(1);
  else if (phone.startsWith("00")) phone = phone.slice(2);
  return phone;
}

export function isValidInternationalPhone(value: string): boolean {
  if (!PHONE_CHARACTERS.test(value.trim())) return false;
  return /^\d{7,15}$/.test(normalizeInternationalPhone(value));
}

export function isValidLoginPhone(value: string): boolean {
  if (!PHONE_CHARACTERS.test(value.trim())) return false;
  return /^\d{3,15}$/.test(normalizeInternationalPhone(value));
}
